import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'trigger']
  static values = {
    type: String,
    side: String
  }

  declare readonly contentTarget: HTMLElement
  declare readonly triggerTarget: HTMLElement
  declare readonly hasTriggerTarget: boolean
  declare readonly typeValue: string
  declare readonly sideValue: string
  declare readonly hasSideValue: boolean

  connect (): void {
    document.addEventListener('scroll', () => this.hide())
  }

  disconnect (): void {
    document.removeEventListener('scroll', () => this.hide())
  }

  show (): void {
    this.contentTarget.classList.remove('hidden')
    if (this.typeValue === 'sidebar') {
      this.sidebarPositionPopover()
    } else if (this.hasSideValue) {
      this.contentTarget.style.position = 'fixed'
      this.contentTarget.style.left = '0px'
      this.contentTarget.style.top = '0px'
      this.contentTarget.style.visibility = 'hidden'
      requestAnimationFrame(() => {
        this.positionPopover()
        this.contentTarget.style.visibility = ''
      })
    }
  }

  hide (): void {
    this.contentTarget.classList.add('hidden')
  }

  private sidebarPositionPopover (): void {
    const triggerElement = this.hasTriggerTarget ? this.triggerTarget : this.element
    const triggerRect = triggerElement.getBoundingClientRect()
    const top = triggerRect.top + triggerRect.height

    this.contentTarget.style.top = `${top}px`
  }

  private positionPopover (): void {
    const triggerElement = this.hasTriggerTarget ? this.triggerTarget : this.element
    const triggerRect = triggerElement.getBoundingClientRect()
    const popoverRect = this.contentTarget.getBoundingClientRect()
    const offset = 8

    let top = 0
    let left = 0

    switch (this.sideValue) {
      case 'left':
        top = triggerRect.top + triggerRect.height / 2 - popoverRect.height / 2
        left = triggerRect.left - popoverRect.width - offset
        break
      case 'right':
        top = triggerRect.top + triggerRect.height / 2 - popoverRect.height / 2
        left = triggerRect.right + offset
        break
      case 'top':
        top = triggerRect.top - popoverRect.height - offset
        left = triggerRect.left + triggerRect.width / 2 - popoverRect.width / 2
        break
      case 'bottom':
      default:
        top = triggerRect.bottom + offset
        left = triggerRect.left + triggerRect.width / 2 - popoverRect.width / 2
    }

    const minLeft = window.scrollX + 8
    const maxLeft = window.scrollX + document.documentElement.clientWidth - popoverRect.width - 8
    const minTop = window.scrollY + 8
    const maxTop = window.scrollY + document.documentElement.clientHeight - popoverRect.height - 8

    left = Math.max(minLeft, Math.min(left, maxLeft))
    top = Math.max(minTop, Math.min(top, maxTop))

    this.contentTarget.style.left = `${left}px`
    this.contentTarget.style.top = `${top}px`
  }
}
